import { render, staticRenderFns } from "./note-icon.vue?vue&type=template&id=f9a33970"
import script from "./note-icon.vue?vue&type=script&lang=js"
export * from "./note-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports